import { render, staticRenderFns } from "./PeoplePicker.vue?vue&type=template&id=5ededc28"
import script from "./PeoplePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeoplePicker.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports